import { AdminAccountDetailsTable } from '../views/index';
import { User } from '../dtos/user';
import { DATE_MDY } from '../../utils/date/index';

export const ADMIN_ACCOUNT_DETAILS_LIST_TABLE = (
	usersList: Array<User> = []
): Array<AdminAccountDetailsTable> => {
	let results: Array<AdminAccountDetailsTable> = [];
	try {
		if (usersList.length > 0) {
			usersList.map((user) => {
				let row = {} as AdminAccountDetailsTable;
				row.action = '';
				row.createdAt = user?.createdAt ? DATE_MDY(user.createdAt) : null;
				row.email = user.email;
				row.fromEmail = user.fromEmail;
				row.firstName = user.firstName;
				row.lastLogin = user?.lastLogin ? DATE_MDY(user.lastLogin) : null;
				row.lastName = user.lastName;
				row.phoneNumber = user.phoneNumber;
				row.userId = user.id;
				row.userType = user.userType;
				row.role = user.role;
				row.accountStatus = user.accountStatus;
				row.addToStripe = user.addToStripe;
				row.isEmailSender = user.isEmailSender;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('ADMIN_ACCOUNT_DETAILS_LIST_TABLE error: ', error);
	}
	return results;
};
